import { render, staticRenderFns } from "./questionTypeAddress.vue?vue&type=template&id=7632d8e2&scoped=true&"
import script from "./questionTypeAddress.vue?vue&type=script&lang=js&"
export * from "./questionTypeAddress.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeAddress.vue?vue&type=style&index=0&id=7632d8e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632d8e2",
  null
  
)

export default component.exports